import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import {  bl_fi_mst_item_line_RowClass, WmsItemHdrContainer } from 'blg-akaun-ts-lib';
import { UomModel } from '../../models/uom.model';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
// import 'rxjs/add/operator/take';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';

interface PricingScheme {
  uom_guid: string;
  label_guid: string;
  price_name: string;
  price_amount: number;
}

@Component({
  selector: 'app-uom-wms-item',
  templateUrl: './uom-wms-item.component.html',
  styleUrls: ['./uom-wms-item.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class UomWmsItemComponent implements OnInit, OnDestroy {

  @Input() uom: FormControl;
  @Input() wmsItem$: Observable<WmsItemHdrContainer>;
  @Output() uomChange = new EventEmitter<FormControl>();
  @Output() selectedUomModel = new EventEmitter<any>();
  @Output() unitPrice = new EventEmitter<number>();
  private subs = new SubSink();
  uomListings = [];

  uomfilterControl = new FormControl();
  filteredUOM$: ReplaySubject<bl_fi_mst_item_line_RowClass[]> = new ReplaySubject<bl_fi_mst_item_line_RowClass[]>(1);
  uomList: bl_fi_mst_item_line_RowClass[];
  selectedUOM;
  selectedPrice;
  baseUOM;
  wmsItem;

  constructor(private cd: ChangeDetectorRef) {

  }

  ngOnInit() {

    this.subs.sink =
      combineLatest([this.wmsItem$]).pipe(
      ).subscribe(
        {
          next: (([item]: any) => {
            this.wmsItem = item;
             this.baseUOM = <any>{
              ...item.bl_wms_item_hdr,
              uom: item.bl_wms_item_hdr.uom,
              quantity: 1
            };

            const baseUomModel = new UomModel();
            baseUomModel.baseUOM = this.baseUOM.uom.toString();
            baseUomModel.fiItemHdrGuid = this.baseUOM.guid.toString();
            baseUomModel.fiItemLineGuid = "";
            baseUomModel.uom = this.baseUOM.uom.toString();
            baseUomModel.uomBaseRatio = 1;
            baseUomModel.isBaseUom = true;


            
            this.uomListings = [
              baseUomModel, 
            ];


            // console.log("Uom Listimg",this.uomListings);
            this.selectedUOM = this.uomListings[0].uom;

            if(this.uom.value){
              this.onUOMSelected(this.uom.value);
            }

            this.filteredUOM$.next(this.uomListings);
          })
        });

        this.subs.sink = this.uomfilterControl.valueChanges.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe({ next: resolve => this.filterUOM(resolve) });

       
  }


  filterUOM(search: string) {
    if (!search) {
      this.filteredUOM$.next(this.uomListings);
    } else {
      search = search.toLowerCase();
      const filter = this.uomListings.filter(l =>
        l.uom.toLowerCase().includes(search));
      this.filteredUOM$.next(filter);
    }
  }

  onUOMSelected(e) {
    //console.log("Even From Selected Uom",e);
    this.selectedUOM = e;
   
    const uom = this.uomListings.find(l => l.uom === e);
    this.selectedUomModel.emit(uom);
    //console.log("UOM", uom);
  }



  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
